"use strict";

var vertical_scroll_pixel_threshold = -30;

angular.module("vendor")
.directive("scroll", function($window) {
    return function(scope, element) {
        var cumulativeUpTranslation = 0;
        var lastPageYOffset = 0;

        angular.element($window).bind("scroll", function() {
            var currentTranslation = this.pageYOffset - lastPageYOffset;
            if (currentTranslation <= 0) {
                cumulativeUpTranslation += currentTranslation;
            }
            else {
                cumulativeUpTranslation = 0;
            }

            if (cumulativeUpTranslation < vertical_scroll_pixel_threshold || this.pageYOffset === 0) {
                element.removeClass("scrolled");
            }
            else if (currentTranslation > 0) {
                element.addClass("scrolled");
            }
            lastPageYOffset = this.pageYOffset;
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/scroll/scroll.directive.js
// module id = 803
// module chunks = 0